export const employerAffairs = (state) => state.affairs.affairs
export const employeeAffairs = (state) => state.affairs.affairs
export const isLoading = (state) => state.affairs.isLoading
export const isSuccess = (state) => state.affairs.isSuccess
export const selectedAffair = (state) => state.affairs.selectedAffair
export const affairsData = (state) => state.affairs
export const employerRequests = (state) => state.affairs.employerRequests
export const selectedRequest = (state) => state.affairs.selectedRequest
export const employeeRequests = (state) => state.affairs.employeeRequests
